module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/create_demand.c37dc608.svg";